import { Link } from 'react-router-dom';
import './index.scss';
import AnimatedLetters from '../AnimatedLetters';
import { useEffect, useState } from 'react';
import Logo from './Logo';

const Home = () => {
  const [letterClass, setLetterClass] = useState('text-animate');
  const nameArray = [' ', 'T', 'i', 'm', ' ', 'C', 'h', 'e', 'n'];
  const jobArray = [
    'S','o','f','t','w','a','r','e',' ',
    'E','n','g','i','n','e','e','r',' ',
    '&',' ',
    'D','a','t','a',' ',
    'A','n','a','l','y','s','t'
  ];

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setLetterClass('text-animate-hover');
    }, 4000);
    return () => clearTimeout(timeoutId);
  }, []);

  return (
    <>
      <div className="container home-page">
        <div className="text-zone">
          <h1>
            <span className={letterClass}>H</span>
            <span className={`${letterClass} _12`}>i,</span>
            <br />
            <span className={`${letterClass} _13`}>I</span>
            <span className={`${letterClass} _14`}>'m </span>
            <AnimatedLetters
              letterClass={letterClass}
              strArray={nameArray}
              idx={15}
            />
            <br />
            <AnimatedLetters
              letterClass={letterClass}
              strArray={jobArray}
              idx={1}
            />
          </h1>
          <h2>Building Scalable Software &amp; Empowering Decisions with Analytics</h2>
          <Link to="/contact" className="flat-button">
            CONTACT ME
          </Link>
          <Link to="/portfolio" className="flat-button flat-button--secondary">
            VIEW MY WORK
          </Link>
        </div>
        <Logo />
      </div>
    </>
  );
};

export default Home;
